itsoftApp.createModule("scrollActions", ["startLoad"], function () {
    const module = this;
    let registeredPlugin = false;
    let registeredScrollTriggerPlugin = false;
    // const getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;

    window.gsapLibraries = {
        gsap: {
            name: "gsap",
            queue: [],
            started: false,
            loaded: false,
            scriptMore: "/assets/scripts/gsap/ScrollTrigger.min.js",
            script: "/assets/scripts/gsap/gsap.min.js"
        }
    };

    const initScrollActions = function (element, scrollTriggerFlag, cb) { 
        const initScrollExemplar = function () {
            if (!registeredPlugin) {
                registeredPlugin = true;

                if (!registeredScrollTriggerPlugin && scrollTriggerFlag) {
                    gsap.registerPlugin(ScrollTrigger); // eslint-disable-line
                }
            }

            if (cb && typeof cb === "function") {
                cb();
            } else {
                if (element.classList.contains("js-batch")) {
                    const borderContainer = document.querySelector(".js-border-container");
                    const steps = element.querySelectorAll(".js-step");

                    borderContainer.classList.add("js-show-active");

                    let mm = gsap.matchMedia();
                    mm.add("(min-width: 1024px)", () => {
                        steps.forEach(function (step) {
                            gsap.set(step, {
                                autoAlpha: 0,
                                y: "-1rem"
                            });
                        });
                        
                        ScrollTrigger.batch(steps, {
                            start: "top bottom",
                            onEnter: batch => gsap.to(batch, {autoAlpha: 1, stagger:{each: 0.2, ease: "power.out"}, duration: 1, y: "0"})
                            // markers: true
                        });
                    });
                }

                if (element.classList.contains("js-outro")) {
                    const batch = element.querySelector(".js-batch");
                    const steps = batch.querySelectorAll(".js-step");
                    const item1 = element.querySelector(".js-item-1");
                    const item2 = element.querySelector(".js-item-2");
                    const logo = element.querySelector(".js-logo");
                    const label = element.querySelector(".js-label");
                    const packs = element.querySelector(".js-packs");

                    steps.forEach(function (step) {
                        gsap.set(step, {
                            autoAlpha: 0,
                            y: "1rem"
                        });
                    });

                    gsap.set(logo, {autoAlpha: 0, scale: 1.2});
                    gsap.set(item1, {autoAlpha: 0, y: "-1rem"});
                    gsap.set(item2, {autoAlpha: 0, y: "1rem"});
                    gsap.set(label, {autoAlpha: 0, scale: 0});
                    gsap.set(packs, {x: "9%", scale: 1.2});

                    gsap.to(logo, {autoAlpha: 1, scale: 1, duration: 1.5});
                    gsap.to(item1, {autoAlpha: 1, y: "0", duration: 1.5});
                    gsap.to(item2, {autoAlpha: 1, y: "0", duration: 1.5});
                    gsap.to(label, {autoAlpha: 1, scale: 1, duration: 1.5});
                    gsap.to(packs, {x: 0, scale: 1, duration: 1});

                    ScrollTrigger.batch(batch, {
                        start: "top 70%",
                        onEnter: batch => gsap.to(steps, {autoAlpha: 1, stagger:{each: -0.3, ease: "power.out"}, duration: 0.3, y: "0",
                        onComplete: function () {
                            const tl = gsap.timeline({
                                scrollTrigger: {
                                    trigger: element,
                                    start: "top top",
                                    scrub: true
                                }
                            });
        
                            tl.to(packs, {x: "9%", scale: 1.2});
                        }})
                    })
                }

                if (element.classList.contains("js-intro")) {

                    // ScrollTrigger.batch(batch, {
                    //     start: "top 70%",
                    //     onEnter: batch => gsap.to(steps, {autoAlpha: 1, stagger:{each: -0.3, ease: "power.out"}, duration: 0.3, y: "0",
                    //     onComplete: function () {
                    //         const tl = gsap.timeline({
                    //             scrollTrigger: {
                    //                 trigger: element,
                    //                 start: "top top",
                    //                 scrub: true
                    //             }
                    //         });
        
                    //         tl.to(packs, {x: "9%", scale: 1.2});
                    //     }})
                    // })

                    let mm = gsap.matchMedia();
                    // mm.add("(min-width: 1024px)", () => {
                        const pageHeader = document.querySelector(".page-header");

                        const palette = element.querySelector(".js-palette");
                        const bgLinesEl = element.querySelector(".js-bg-lines");
                        const picture = element.querySelector(".js-picture");
                        const introTitle = element.querySelector(".js-intro-title");
                        const batchEl1 = element.querySelector(".js-batch-el-1");
                        const batchEl2 = element.querySelector(".js-batch-el-2");
                        const batchEl3 = element.querySelector(".js-batch-el-3");
                        const stand1 = element.querySelector(".js-stand-1");
                        const stand2 = element.querySelector(".js-stand-2");
                        const stand3 = element.querySelector(".js-stand-3");
                        const stand4 = element.querySelector(".js-stand-4");
                        const badge = element.querySelector(".js-badge");

                        // gsap.set(pageHeader, {
                        //     autoAlpha: 0,
                        //     yPercent: -100
                        // });
                        gsap.set(palette, {autoAlpha: 0, scale: 0});
                        gsap.set(bgLinesEl, {width: '0%'});
                        gsap.set(picture, {autoAlpha: 0, scale: 0.5});
                        gsap.set(introTitle, {autoAlpha: 0});
                        gsap.set(batchEl1, {autoAlpha: 0});
                        gsap.set(batchEl2, {autoAlpha: 0});
                        gsap.set(batchEl3, {autoAlpha: 0});
                        gsap.set(stand1, {autoAlpha: 0, yPercent: 100});
                        gsap.set(stand2, {autoAlpha: 0, yPercent: 100});
                        gsap.set(stand3, {autoAlpha: 0, yPercent: 100});
                        gsap.set(stand4, {autoAlpha: 0, yPercent: 100});
                        gsap.set(badge, {autoAlpha: 0, scale: 2, rotate: -60});

                        gsap.set(element, {opacity: 1});

                        // ScrollTrigger.create({
                        //     trigger: element,
                        //     start: "bottom top",
                        //     once: true,
                        //     onEnter: function () {
                        //         gsap.to(pageHeader, {
                        //             duration: 0.5,
                        //             autoAlpha: 1,
                        //             yPercent: 0
                        //         })
                        //     }
                        // });

                        const tl = gsap.timeline({});

                        tl.addLabel("origin")
                        .to(palette, {
                            duration: 1,
                            scale: 1,
                            autoAlpha: 1
                        }, ">-0.3")
                        .addLabel("palette")
                        .to(picture, {
                            duration: 1,
                            scale: 1,
                            autoAlpha: 1,
                            x: '0%', 
                            ease: "power3.out"
                        }, ">-0.3")
                        .addLabel("picture")
                        // .to(bgLinesEl, {
                        //     duration: 2,
                        //     width: '100%'
                        // }, ">-0.5")
                        // .addLabel("bgLinesEl")
                        .to(batchEl1, {
                            duration: 0.45,
                            autoAlpha: 1,
                            yPercent: 0
                        }, "picture-=0.4")
                        .to(batchEl2, {
                            duration: 0.45,
                            autoAlpha: 1,
                            yPercent: 0
                        }, ">-0.2")
                        .to(batchEl3, {
                            duration: 0.45,
                            autoAlpha: 1,
                            yPercent: 0
                        }, ">-0.2")
                        .addLabel("batchEls")
                        .to(introTitle, {
                            duration: 1,
                            autoAlpha: 1
                        }, ">-0.05")
                        .addLabel("introTitle")
                        .to(stand1, {
                            duration: 0.35,
                            autoAlpha: 1,
                            yPercent: 0
                        }, "batchEls-=0.05")
                        .to(stand2, {
                            duration: 0.45,
                            autoAlpha: 1,
                            yPercent: 0
                        }, ">-0.3")
                        .to(stand3, {
                            duration: 0.45,
                            autoAlpha: 1,
                            yPercent: 0
                        }, ">-0.3")
                        .addLabel("stand3")
                        .to(stand4, {
                            duration: 0.45,
                            autoAlpha: 1,
                            yPercent: 0
                        }, "stand3-=0.75")
                        .to(badge, {
                            duration: 0.45,
                            autoAlpha: 1,
                            scale: 1,
                            rotate: 0
                        }, ">-0.1")
                        .addLabel("stands")
                        // .addLabel("default");
                    // });
                }
            }
        };

        new itsoftApp.modules.startLoad.callback(initScrollExemplar, gsapLibraries.gsap);
    };

    module.callback = initScrollActions;
});